import { connect } from 'react-redux';
import { trackEvent } from '../../user-tracking/actions';
import ErrorBoundary from './error-boundary';

export default connect(null, { trackEvent })(ErrorBoundary);
